<template>
    <v-content>
        <v-container grid-list-xl>
            <v-layout justify-center>
                <v-flex xs12 xl6>
                    <v-toolbar color="secondary" dark>
                        <img src="logo.png">
                        <v-spacer></v-spacer>
                        <h2 :style="$store.state.textFormatting.headers"> 
                            {{currentPage}}
                        </h2>
                    </v-toolbar>
                    <v-card>
                        <v-card-text>
                            <v-layout justify-center>
                                <v-flex xs12>
                                    <v-form ref="CompleteSignUp" v-model="valid" lazy-validation v-if="currentPage == 'Complete Sign Up'">
                                        <h3 :style="$store.state.textFormatting.main"> An email has been send from 'no-reply@verificationemail.com', this will contain a code and your username, please enter below.
                                        </h3>
                                        <br> <p :style="$store.state.textFormatting.main">Note: it is recomended that following confirmation to change user password</p>
                                        <v-text-field :style="$store.state.textFormatting.main" v-on:keyup.enter="confirmSignUp(username, code)" v-model="username" label="Username" required></v-text-field>
                                        <v-text-field :style="$store.state.textFormatting.main" :rules="codeRules" v-on:keyup.enter="confirmSignUp(username, code)" v-model="code" :counter="6" label="Code" required></v-text-field>
                                        <h3 :style="$store.state.textFormatting.main"> {{message}} </h3>
                                        <v-progress-circular v-if="loading" indeterminate color="purple" ></v-progress-circular>
                                        <v-btn color="green" dark @click="confirmSignUp(username, code)" :style="$store.state.textFormatting.main"> Submit </v-btn>
                                    </v-form>
                                    <v-form ref="ChangePassword" v-model="valid" lazy-validation v-if="currentPage == 'Change Password'" >
                                        <h3 :style="$store.state.textFormatting.main"> In order to change your password we will send you a code, enter your username and 
                                            press 'send email' to receive code via email: </h3>
                                        <v-layout>
                                            <v-flex xs12 md9>
                                                <v-text-field :style="$store.state.textFormatting.main" label="Username" v-model="username" v-on:keyup.enter="sendForgotEmailCode(username)"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md3>
                                                <v-btn :style="$store.state.textFormatting.main" color="green" dark @click="sendForgotEmailCode(username)" small> Send Email </v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <h3 color="red" :style="$store.state.textFormatting.main"> {{message}} </h3>
                                        <v-divider v-if="NewPasswordEmailSendForm"></v-divider>
                                        
                                        <div v-if="NewPasswordEmailSendForm">
                                            <h3 :style="$store.state.textFormatting.main">
                                                Please re-enter your username, code and new password and select submit.
                                            </h3>
                                            <v-text-field :style="$store.state.textFormatting.main" label="Username" v-model="username" v-on:keyup.enter="SendNewPassword(username, code, password)"></v-text-field>
                                            <v-text-field :style="$store.state.textFormatting.main" label="Code"  :rules="codeRules" v-model="code" v-on:keyup.enter="SendNewPassword(username, code, password)"></v-text-field>
                                            <v-text-field 
                                            :style="$store.state.textFormatting.main"
                                            label="New Password" 
                                            :rules="passwordRules" 
                                            v-model="password" min="8" 
                                            :append-icon="show4 ? 'visibility' : 'visibility_off'"
                                            @click:append="show4 = !show4" 
                                            :type="show4 ? 'text' : 'password'" 
                                            required 
                                            v-on:keyup.enter="SendNewPassword(username, code, password)"></v-text-field>
                                            <v-btn color="green" dark @click="SendNewPassword(username, code, password)"> Submit </v-btn>
                                        </div>
                                    </v-form>
                                    <v-form ref="SignIn" v-if="currentPage == 'Sign In'">
                                        <v-text-field :style="$store.state.textFormatting.main" v-on:keyup.enter="signIn(username, password)" v-model="username" :counter="64" label="Username" required></v-text-field>
                                        <v-text-field :style="$store.state.textFormatting.main" v-on:keyup.enter="signIn(username, password)" :type="'password'" v-model="password"  label="Password" required></v-text-field> 
                                        <h3 :style="$store.state.textFormatting.main" v-if="showErr">{{message}}</h3>
                                        <v-btn :style="$store.state.textFormatting.main" color="green" dark @click="signIn(username, password)"> Submit </v-btn>
                                        <v-progress-circular v-if="loading" indeterminate color="purple" ></v-progress-circular>
                                    </v-form>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn :style="$store.state.textFormatting.main" color="green" dark @click="ChangeBetweenTabs('Sign In')" :disabled="sign_in_disabled"> sign in </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn :style="$store.state.textFormatting.main" color="blue" dark @click="ChangeBetweenTabs('Change Password')" :disabled="change_password_disabled"> Change Password </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn :style="$store.state.textFormatting.main" color="red" dark @click="ChangeBetweenTabs('Complete Sign Up')" :disabled="complete_signup_disabled"> Complete Sign Up </v-btn>
                        </v-card-actions>
                    </v-card>
                    
                </v-flex>
            </v-layout>
            <v-layout justify-center>

                <v-flex xs12 md8>
                    <h2 :style="$store.state.textFormatting.main" class="text-xs-center"> <br /> <i> This tool has been developed jointly by BT and the UK's National Cyber Security Centre.
                         The network protocol data provided in this tool is for the benefit of all users and 
                         may be utilised without restriction. Users may include UK and international government 
                         agencies who will be free to use the data to carry out their statutory functions. </i>
                    </h2>
                </v-flex>
            </v-layout>
            
            <!-- <v-btn @click="testSendEmail('NLayton006')"> click to test</v-btn>
            <v-btn @click="testCodeConf('NLayton006', '976038', 'Password_2')"> click to test2</v-btn> -->
        </v-container>
    </v-content>
</template>


      

<script>
import { Auth } from 'aws-amplify';
import { AmplifyEventBus } from 'aws-amplify-vue';

export default {
    name: 'authentication',
    data () {
        return {
            codeRules: [ v => !!v || 'A valid 6 digit code is required', v => /^[0-9]{6}$/.test(v) || 'Must be a valid 6 digit number' ],
            passwordRules: [ v => !!v || 'A valid Password is required', v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/.test(v) || 'Password must be over 8 characters long and contain 1 uppercase, 1 lowercase, 1 special char (@$!%*?&_) and 1 number'],
            username: null,
            code: null,
            message: null,
            ConfirmationCode: null,
            ConfirmUser: true,
            showErr: false,
            password:null,
            currentPage: "Sign In",
            NewPasswordEmailSendForm: false,
            show4: false,
            loading: false,
            sign_in_disabled: true,
            change_password_disabled: false,
            complete_signup_disabled: false
        }
    },
    methods: {
        ChangeBetweenTabs: function (page) {
            if (page == 'Sign In') {
                console.log("signin")
                this.sign_in_disabled = true
                this.change_password_disabled = false
                this.complete_signup_disabled = false
            } else if (page == 'Change Password') {
                console.log("change pass")
                this.sign_in_disabled = false
                this.change_password_disabled = true
                this.complete_signup_disabled = false
            } else {
                console.log("compl signup")
                this.sign_in_disabled = false
                this.change_password_disabled = false
                this.complete_signup_disabled = true
            }
            this.currentPage=page;
            this.message= null;
            this.password= null;
            this.username=null;
        },
        sendForgotEmailCode: function (username) {
            this.loading=true;
            try {
                
                Auth.forgotPassword(username)
                .then(data =>  {
                    this.NewPasswordEmailSendForm= true
                    this.message=null
                    console.log(data)}
                    )
                .catch(err => {
                    this.message=err.message
                    this.NewPasswordEmailSendForm= false
                });
                
            }
            catch (err) {
                this.message="User does not exist"
            }
            this.loading=false;
        },
        SendNewPassword: function (username, code, new_password) {
            this.loading=true;
            try {
                Auth.forgotPasswordSubmit(username, code, new_password)
                    .then(data =>  {
                        this.message="Success, your password has been changed"
                        console.log(data)
                    })
                    .catch(err => console.log(err));
                    this.currentPage = "Sign In"
                    this.$refs.ChangePassword.reset()
            } catch (err) {
                console.log(err)
            }
            this.loading=false;
            
        },
        signIn: async function () {
            this.showErr = false;
            this.loading = true;
            
            try {
                Auth.signIn(this.username, this.password)
                .then(data => {
                    console.log(data)
                    this.$store.state.user_debug = data
                    this.message=null
                    return AmplifyEventBus.$emit('authState', 'signedIn')
                    })
                .catch(err => {
                    
                    this.message= err.message
                    console.log(err)
                    this.showErr = true;
                    this.loading=false; 
                });
                //this.$refs.signIn.reset()
            }
            catch (err) {
                console.log(err)
                this.message=err.message
                this.showErr = true;
                this.loading=false; 
            }
            
        },
        confirmSignUp: async function (username, code) {
            this.loading=true;
            try {
                Auth.confirmSignUp(username, code)
                .then(data => {
                    //this.currentPage = "Sign In"
                    this.$refs.CompleteSignUp.reset()
                    this.message="Your user has been confirmed, it is recommended that you navigate to 'CHANGE PASSWORD' before signing in."
                    console.log(data)
                    this.loading=false;
                })
                .catch(err => {
                    this.message= err.message
                    console.log(err)
                    this.loading=false;
                })
            }
            catch (err) {
                console.log(err)
                this.loading=false;
            }
            
        }
    }
}
</script>

